import React, { useRef } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';

interface FileInputProps {
    value: File | null;
    onChange: (file: File | null) => void;
    label: string;
    accept?: string;
    size?: 'small' | 'medium';
    removeTitle?: string;
}

const FileInput = ({
    value,
    onChange,
    label,
    accept = '.csv, .txt',
    size = 'small',
    removeTitle = 'Remove'
}: FileInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null;
        onChange(file);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    const handleClear = () => {
        onChange(null);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    const handleClick = () => {
        inputRef.current?.click();
    };

    return (
        <>
            <TextField
                fullWidth
                label={label}
                value={value?.name || ''}
                onClick={handleClick}
                size={size}
                InputProps={{
                    readOnly: true,
                    startAdornment: (
                        <InputAdornment position="start">
                            <AttachFileIcon />
                        </InputAdornment>
                    ),
                    endAdornment: value && (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleClear();
                                }}
                                title={removeTitle}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                    style: { cursor: 'pointer' }
                }}
                sx={{ mb: 2 }}
            />
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
};

export default FileInput;
